import { cpf as CPF, cnpj as CNPJ } from 'cpf-cnpj-validator'

export default (mask, options, inputValues) => {
  switch (mask) {
    case 'cnpj': {
      return {
        validations: {
          isLength: 14,
          cpfCnpj: (values, value) => CNPJ.isValid(value),
        },
        validationErrors: {
          isLength: 'O CNPJ precisa ter 14 caracteres',
          cpfCnpj: 'CNPJ inválido.',
        },
      }
    }
    case 'cpf': {
      return {
        validations: {
          isLength: 11,
          cpf: (values, value) => CPF.isValid(value),
        },
        validationErrors: {
          isLength: 'O CPF precisa ter 11 caracteres',
          cpf: 'CPF inválido.',
        },
      }
    }
    case 'cpf_cnpj': {
      return {
        validations: {
          cpfCnpj: (values, value) => (CPF.isValid(value) || CNPJ.isValid(value)),
        },
        validationErrors: {
          cpfCnpj: 'CPF/CNPJ inválido.',
        },
      }
    }
    case 'plate': {
      return {
        validations: {
          isLength: 8,
        },
        validationErrors: {
          isLength: 'A placa precisa ter 3 caracteres e 4 dígitos.',
        },
      }
    }
    case 'renavam': {
      return {
        validations: {
          maxLength: 11,
          minLength: 9,
        },
        validationErrors: {
          isLength: 'O renavam deve conter no máximo 11 dígitos.',
          minLength: 'O renavam deve conter no mínimo 3 dígitos.',
        },
      }
    }
    case 'chassi': {
      return {
        validations: {
          isLength: 17,
          chassiError: () => (options && inputValues
            && options.defaultChassi !== null
            && options.defaultChassi.substr(options.defaultChassi.length - 5)
            === inputValues.chassi.substr(inputValues.chassi.length - 5)),
        },
        validationErrors: {
          isLength: 'O número de chassi deve conter 17 dígitos.',
          chassiError: 'O chassi deve conferir com o chassi identificado acima.',
        },
      }
    }
    case 'name': {
      return {
        validations: {
          minLength: 4,
        },
        validationErrors: {
          minLength: 'O nome deve ter pelo menos 4 caracteres',
        },
      }
    }
    case 'email': {
      return {
        validations: {
          minLength: 4,
          isEmail: true,
        },
        validationErrors: {
          minLength: 'O nome deve ter pelo menos 4 caracteres',
          isEmail: 'Informe um email válido',
        },
      }
    }
    default: {
      return null
    }
  }
}
